import React, { RefObject } from 'react';

import {
  Box,
  InputMessage,
  InputLabel,
  Select,
  SelectOptionType,
} from '@chargify/custom-ui-components';

import { MessageContainer } from './SelectField.styles';

type SelectFieldProps = {
  value: string | number;
  label: string;
  name: string;
  options: SelectOptionType[];
  error?: string;
  required?: boolean;
  placeholder?: string;
  onChange: (value: string | number) => void;
  onValidateField: (value: string | number) => void;
  isLoadingOptions?: boolean;
  selectOptionLabel: string;
  searchLabel: string;
  targetElementRef?: RefObject<HTMLElement>;
};

const SelectField = ({
  value,
  label,
  name,
  options,
  error,
  required,
  placeholder,
  onChange,
  onValidateField,
  selectOptionLabel,
  searchLabel,
  isLoadingOptions,
  targetElementRef,
}: SelectFieldProps) => (
  <>
    <Box marginBottom={2}>
      <InputLabel label={label} htmlFor={name} required={required} />
    </Box>
    <Select
      id={name}
      name={name}
      selectedValue={value}
      onSelect={({ value }) => onChange(value)}
      onBlur={({ value }) => onValidateField(value)}
      options={options}
      filterable
      placeholder={placeholder}
      hasError={!!error}
      optionsLoading={isLoadingOptions}
      searchLabel={searchLabel}
      selectOptionLabel={selectOptionLabel}
      targetElementRef={targetElementRef}
    />
    <MessageContainer type="error" marginTop={2}>
      {error && <InputMessage message={error} type="error" />}
    </MessageContainer>
  </>
);

export default SelectField;
